import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, ExternalLink } from 'lucide-react';
import { ChatMarkdown } from './ChatMarkdown';

export const CHARLIE_AVATAR = '/charlie-echo-avatar.png';

const SourceChip = ({ source, onNavigate }) => {
  const label = source.title.replace(/^PDF:\s*/, '');
  const cls = 'inline-flex items-center gap-1 max-w-full rounded-full border border-slate-200 bg-white px-2.5 py-1 text-[11px] font-medium text-slate-600 hover:border-blue-300 hover:text-blue-700 transition-colors';
  if (source.type === 'pdf') {
    return (
      <a href={source.href} target="_blank" rel="noopener noreferrer" className={cls} data-testid="charlie-source-chip">
        <FileText className="h-3 w-3 text-orange-500 flex-shrink-0" /><span className="truncate">{label}</span>
      </a>
    );
  }
  return (
    <Link to={source.href} onClick={onNavigate} className={cls} data-testid="charlie-source-chip">
      <ExternalLink className="h-3 w-3 text-blue-500 flex-shrink-0" /><span className="truncate">{label}</span>
    </Link>
  );
};

export const TypingDots = () => (
  <span className="inline-flex items-center gap-1 py-1" aria-label="Charlie Echo is typing" data-testid="charlie-typing">
    {[0, 1, 2].map((i) => (
      <span key={i} className="h-1.5 w-1.5 rounded-full bg-blue-400 animate-bounce" style={{ animationDelay: `${i * 150}ms` }} />
    ))}
  </span>
);

export const ChatMessage = ({ message, onNavigate }) => {
  const isUser = message.role === 'user';
  if (isUser) {
    return (
      <div className="flex justify-end" data-testid="charlie-msg-user">
        <div className="max-w-[85%] rounded-2xl rounded-br-md bg-blue-600 px-4 py-2.5 text-sm text-white shadow-sm whitespace-pre-wrap">
          {message.content}
        </div>
      </div>
    );
  }
  return (
    <div className="flex items-end gap-2" data-testid="charlie-msg-assistant">
      <img src={CHARLIE_AVATAR} alt="" className="h-8 w-8 rounded-full object-cover ring-2 ring-white shadow flex-shrink-0 mb-1" />
      <div className="max-w-[85%] space-y-2">
        <div className={`rounded-2xl rounded-bl-md px-4 py-2.5 text-sm shadow-sm ${message.error ? 'bg-red-50 text-red-700 border border-red-100' : 'bg-white text-slate-700 border border-slate-100'}`}>
          {message.content ? <ChatMarkdown text={message.content} onNavigate={onNavigate} /> : <TypingDots />}
        </div>
        {message.sources?.length > 0 && (
          <div className="flex flex-wrap gap-1.5 pl-1" data-testid="charlie-sources">
            {message.sources.map((s) => <SourceChip key={s.href} source={s} onNavigate={onNavigate} />)}
          </div>
        )}
      </div>
    </div>
  );
};
